import * as React from "react";

function SvgImprovely(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 90 105"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <g fillRule="evenodd" clipRule="evenodd" fill="#385671">
        <path d="M74.689 102.935H61.008V30.758c4.326-.756 8.899-.268 13.375-.28 1.257 3.813 1.494 66.859.306 72.457zM30.812 102.796V52.959h13.726c1.057 3.399 1.465 40.87.474 49.837h-14.2zM14.138 102.942H0V74.311h14.138v28.631zM78.224 11.275c-.11 5.49-4.698 9.888-10.328 9.898-5.641.01-9.976-4.238-9.817-9.621.166-5.618 5.13-10.113 10.93-9.896 5.415.202 9.322 4.281 9.215 9.619z" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgImprovely);
